import axiosRequest from '@/utils/axios-default-request';

//获取概览页基础信息---传入登录用户id
let getOverviewData =(data)=> axiosRequest.postBody('/supinterface/getOverviewData',data)

//获取数据字典信息
let getDataAll = (data)=>axiosRequest.postBody('/supinterface/getDictData',data)

//获取国籍/地区信息  层级结构的数据
let getDataNational = (data)=>axiosRequest.postBody('/supinterface/getWhNationalityData',data)

//获取语种/母语信息
let getDataNativeLanguage = (data)=>axiosRequest.postBody('/supinterface/getWhMotherTongueData',data)

//获取领域信息
let getDataWhField =(data)=>axiosRequest.postBody('/supinterface/getWhFieldData',data)

//获取性别下拉  
let getSupSexData =(data)=>axiosRequest.postBody('/supinterface/getSexData',data)

//获取翻译年限  
let getTranslationYearsData =(data)=>axiosRequest.postBody('/supinterface/getTranslationYearsData',data)


// 获取来源信息下拉
let getSourceData =(data)=>axiosRequest.postBody('/supinterface/getSourceData',data)

//获取币种
let getCurrencyData =(data)=>axiosRequest.postBody('/supinterface/getCurrencyData',data)

// 获取接稿时间多选列表
let getJiegaoTimeData =(data)=>axiosRequest.postBody('/supinterface/getJiegaoTimeData',data)

//新增/编辑基础信息
let addBasicSupInfo =(params)=>axiosRequest.postBodyJson('/supinterface/addOrEditSupInfo',params)

//新增/编辑联系方式
let addSupContact =(data)=>axiosRequest.postBodyJson('/supinterface/addOrEditSupContact',data)

//新增/编辑产量/接稿/语种信息
let addSupProduct =(data)=>axiosRequest.postBodyJson('/supinterface/addOrEditSupCJY',data)

//获取Basic基础信息form表单
let getSupInfoBasicsData=(data)=>axiosRequest.postBody('/supinterface/getSupInfoBasicsData',data)

//获取Basic联系方式form表单
let getSupContactData = (data)=>axiosRequest.postBody('/supinterface/getSupContactData',data)

//获取Basic语种及产量form表单
let getSupCJYData = (data)=>axiosRequest.postBody('/supinterface/getSupCJYData',data)

//获取Basic语种及产量form表单
let delEstimateYield = (data)=>axiosRequest.postBody('/supinterface/delEstimateYield',data)
// 性别：getSexData
// 翻译年限：getTranslationYearsData
// 币种：getCurrencyData
// 获取国籍地区：getWhNationalityData
// 母语：getWhMotherTongueData
// 领域：getWhFieldData
// 删除语种及产量  delEstimateYield

// 修改手机号
let getChangeThePhone = (data) => axiosRequest.postBodyJson('/supinterface/getChangeThePhone',data)

// 修改邮箱
let getChangeTheBindingMail = (data) => axiosRequest.postBodyJson('/supinterface/getChangeTheBindingMail',data)



// 客户端修改手机号
let xqgetChangeThePhone = (data) => axiosRequest.postBodyJson('/supinterface/getChangeThePhone',data)

// 客户端修改邮箱
let xqgetChangeTheBindingMail = (data) => axiosRequest.postBodyJson('/supinterface/getChangeTheBindingMail',data)


export default{
    getDataAll,//数据字典信息
    getDataNational,//获取国籍地区信息
    getDataNativeLanguage,//获取母语信息
    getDataWhField,//获取领域下拉信息
    getJiegaoTimeData,//获取接稿时间多选列表
    addBasicSupInfo,//新增/编辑基础信息
    addSupContact,//新增/编辑联系方式
    addSupProduct,//新增/编辑产量/接稿/语种信息
    getOverviewData,//概览页基础信息
    getSupSexData,// 获取性别下拉
    getCurrencyData,//获取币种
    getSourceData,//获取来源下拉
    getTranslationYearsData,//获取翻译年限
    getSupInfoBasicsData,//获取Basic基础信息form表单
    getSupContactData,//获取Basic联系方式form表单
    getSupCJYData,//获取Basic语种及产量form表单
    delEstimateYield,//删除语种及产量

    getChangeThePhone,//修改手机号接口
    getChangeTheBindingMail,//修改邮箱账号
    xqgetChangeThePhone,//修改手机号接口--客户端
    xqgetChangeTheBindingMail,//修改邮箱账号--客户端
    
}